import { axiosUtils } from "../../../../network/axiosUtils";
import httpRequest from "../../../../network/httpRequest";
import { HttpResponse } from "../../../../network/types";
import { handleError } from "../../../../shared/utils";

export const uploadImage = async (FormData: FormData) => {
  try {
    const response: HttpResponse = await httpRequest({
      method: axiosUtils.POST,
      url: `/media/small-images`,
      requestBody: FormData,
    });
    return response?.data.rows;
  } catch (err) {
    const { error } = handleError(err);
    throw new Error(error.message);
  }
};
